/**
 * LOSFILTROS – AI Generator Widget v2
 * Shopify Admin → Online Store → Themes → Edit code → Assets → widget.js
 */

(function () {
  "use strict";

  const WORKER       = (window._lf?.workerUrl) || "https://lucky-fog-5ec4.drapelajan6.workers.dev";
  const REGISTER_URL = "/account/register";
  const BUY_URL      = "/products/ai-kredity";

  const PRODUCT_TYPES = {
    product_tshirt:   { label: "Tričko",   ratio: 0.75,  printX: 28, printY: 20, printW: 44, printH: 42 }, // ratio ověřeno z Gelato šablony (12x16" max print area)
    product_raglan:   { label: "Raglan tričko (3/4 rukáv)", ratio: 1, printX: 28, printY: 20, printW: 44, printH: 42 }, // TODO: doladit skutečné rozměry z Gelato
    product_ringer:   { label: "Ringer tričko", ratio: 1, printX: 28, printY: 28, printW: 44, printH: 42 }, // pozice změřená podle skutečného Gelato draftu (motiv je v Gelatu nižší než v původním náhledu)
    product_longsleeve: { label: "Tričko s dlouhým rukávem", ratio: 1, printX: 28, printY: 20, printW: 44, printH: 42 }, // TODO: doladit skutečné rozměry z Gelato
    product_mug_11oz:        { label: "Keramický hrnek 325ml",    ratio: 200/96,  printX: 15, printY: 25, printW: 70, printH: 50 }, // ratio ověřen (200x96mm), pozice TODO
    product_mug_15oz:        { label: "Keramický hrnek 440ml",    ratio: 213/103, printX: 15, printY: 25, printW: 70, printH: 50 }, // ratio ověřen (213x103mm), pozice TODO
    product_mug_enamel_12oz: { label: "Smaltovaný hrnek 350ml",   ratio: 180/60,  printX: 15, printY: 25, printW: 70, printH: 50 }, // ratio ověřen (180x60mm), pozice TODO
    product_mug_17oz_tall:   { label: "Keramický hrnek 500ml (latte, vysoký)", ratio: 208/129, printX: 15, printY: 25, printW: 70, printH: 50 }, // ratio ověřen (Gelato tabulka: Latte 17oz 208x129mm flat), pozice TODO. Kónický tvar - design se při výrobě mírně zdeformuje
    product_mug_travel_15oz: { label: "Cestovní hrnek nerezový 440ml", ratio: 82/125, printX: 20, printY: 30, printW: 60, printH: 40 }, // ratio ověřen (82x125mm flat), pozice TODO. POZOR: kónický tvar, design se při výrobě mírně zdeformuje
    product_bottle_17oz:     { label: "Nerezová láhev 500ml",     ratio: 87/110,  printX: 25, printY: 25, printW: 50, printH: 50 }, // ratio ověřen (87x110mm), pozice TODO
    product_mug_10oz_slim:   { label: "Porcelánový útlý hrnek",   ratio: 175/75,  printX: 15, printY: 25, printW: 70, printH: 50 }, // ratio ověřen (175x75mm), pozice TODO
    product_hoodie:   { label: "Mikina",   ratio: 1,     printX: 28, printY: 22, printW: 44, printH: 40 }, // ratio ověřen z Gelato šablony (12x12in), pozice zatím jen odhad z náčrtu, ne z reálné mockup fotky
    product_bag:      { label: "Taška",    ratio: 1,     printX: 27, printY: 47, printW: 46, printH: 40 }, // printY 42 -> 47: ODHAD (motiv má být v náhledu o něco níž), ještě neověřeno porovnáním s Gelato draftem
    product_cap:      { label: "Čepice",   ratio: 1.5,   printX: 25, printY: 30, printW: 50, printH: 40 },
    product_poster:   { label: "Plakát",   ratio: 0.707, printX:  0, printY:  0, printW: 100, printH: 100 },
    product_poster_matte_premium: { label: "Premium matný plakát (nerámovaný)", ratio: 0.667, printX: 0, printY: 0, printW: 100, printH: 100 }, // ratio je výchozí, skutečná orientace se odvodí z velikosti varianty
    product_poster_matte_classic: { label: "Klasický matný plakát (nerámovaný)", ratio: 0.75, printX: 0, printY: 0, printW: 100, printH: 100 },
    product_poster_glossy_classic: { label: "Klasický pololesklý plakát (nerámovaný)", ratio: 0.75, printX: 0, printY: 0, printW: 100, printH: 100 },
    product_poster_glossy_premium: { label: "Premium pololesklý plakát (nerámovaný)", ratio: 0.667, printX: 0, printY: 0, printW: 100, printH: 100 },
    product_canvas: { label: "Obraz na plátně (canvas)", ratio: 0.667, printX: 0, printY: 0, printW: 100, printH: 100 },
    product_canvas_framed: { label: "Zarámovaný obraz (dřevěný rám)", ratio: 0.667, printX: 5, printY: 5, printW: 90, printH: 90 }, // MÁ rám - TODO: doladit podle skutečné mockup fotky
    // Rámované plakáty MAJÍ viditelný rám kolem tiskové plochy - NENÍ přes
    // celou fotku, potřebují červený obdélník na skutečné mockup fotce
    // (viz dřívější hlášená deformace/přesah přes rám).
    product_poster_framed_wood_classic: { label: "Klasický matný plakát v dřevěném rámu", ratio: 0.667, printX: 5, printY: 5, printW: 90, printH: 90 }, // TODO: doladit podle skutečné mockup fotky (rám!)
    product_poster_framed_wood_glossy_classic: { label: "Klasický pololesklý plakát v dřevěném rámu", ratio: 0.667, printX: 5, printY: 5, printW: 90, printH: 90 }, // TODO: doladit podle skutečné mockup fotky (rám!)
    product_poster_framed_metal_glossy: { label: "Pololesklý plakát v hliníkovém rámu, černý", ratio: 0.667, printX: 5, printY: 5, printW: 90, printH: 90 }, // TODO: doladit podle skutečné mockup fotky (rám!)
    product_poster_framed_metal_matte: { label: "Klasický matný plakát v hliníkovém rámu, černý", ratio: 0.667, printX: 5, printY: 5, printW: 90, printH: 90 }, // TODO: doladit podle skutečné mockup fotky (rám!)
    // PREMIUM (200gsm) rámované plakáty - samostatné tagy, ať se nevytiskne klasický papír
    product_poster_framed_wood_matte_premium:   { label: "Premium matný plakát v dřevěném rámu",      ratio: 0.667, printX: 5, printY: 5, printW: 90, printH: 90 },
    product_poster_framed_wood_glossy_premium:  { label: "Premium pololesklý plakát v dřevěném rámu", ratio: 0.667, printX: 5, printY: 5, printW: 90, printH: 90 },
    product_poster_framed_metal_matte_premium:  { label: "Premium matný plakát v kovovém rámu",       ratio: 0.667, printX: 5, printY: 5, printW: 90, printH: 90 },
    product_poster_framed_metal_glossy_premium: { label: "Premium pololesklý plakát v kovovém rámu",  ratio: 0.667, printX: 5, printY: 5, printW: 90, printH: 90 },
    product_poster_hanging_classic: { label: "Plakát s ramínkem - klasický (170gsm)", ratio: 0.667, printX: 0, printY: 0, printW: 100, printH: 100 }, // přes celou plochu, bez rámu
    product_poster_hanging_premium: { label: "Plakát s ramínkem - premium (200gsm)", ratio: 0.667, printX: 0, printY: 0, printW: 100, printH: 100 },
    product_calendar: { label: "Kalendář", ratio: 0.707, printX:  5, printY:  5, printW: 90, printH: 90 },
  };

  // Produkty se zachovaným pozadím: jakýkoliv tag začínající "product_poster"
  // nebo "product_canvas", plus "product_calendar". Kontrola podle předpony
  // místo pevného seznamu - funguje automaticky i pro budoucí nové varianty.
  function keepsBackground(productType) {
    if (!productType) return false;
    return productType === "product_calendar"
        || productType.startsWith("product_poster")
        || productType.startsWith("product_canvas");
  }

  // Mapování styl → Shopify kolekce (handle), pro cross-sell nabídku po
  // vygenerování: "stejný obrázek i na dalších produktech tohoto stylu".
  const STYLE_COLLECTIONS = {
    style_cyberpunk:   "pixar-style",
    style_yellowtown:  "zluta-ves-1",
    style_comics:      "ghibli-style",
    style_popart:      "ps2-style-2",
    style_anime:       "anime-1",
    style_oilpainting: "renesancni-olejomalba-1",
    style_watercolor:  null, // TODO: doplnit handle kolekce
  };

  let state = {
    customerId:    window._lf?.customerId || null,
    productTags:   window._lf?.productTags || [],
    productHandle: window._lf?.productHandle || "",
    gelatoUid:     window._lf?.gelatoUid || "",
    styleTag:      null,
    productType:   null,
    productConfig: null,
    credits:       0,
    remaining:     3,
    freeLimit:     3,
    canGenerate:   true,
    isBlocked:     false,
    blockedUntil:  null,
    crop:          null,  // { naturalWidth, naturalHeight, coverScale, scale, offsetX, offsetY, viewportW, viewportH }
    generatedImage: null,
    previewUrl:     null,
    cleanPreviewUrl: null,
    overlayOffsetX: 0,
    overlayOffsetY: 0,
    hasPurchasedCredits: false,
    originalImageDataUrl: null,
  };

  // ════════════════════════════════════════════════════════════════
  // INIT
  // ════════════════════════════════════════════════════════════════
  let gelatoMapCache = null;

  async function getGelatoMap() {
    if (gelatoMapCache) return gelatoMapCache;
    try {
      const res = await fetch(`${WORKER}/gelato-map`);
      gelatoMapCache = await res.json();
    } catch (err) {
      console.warn("[LF] Načtení gelato mapy selhalo:", err.message);
      gelatoMapCache = {};
    }
    return gelatoMapCache;
  }

  // Dohledá gelatoUid podle typu produktu, podtypu (classic/premium),
  // velikosti a barvy. Gelato UID se váže na FYZICKÝ produkt - u oblečení
  // často i podle VELIKOSTI, ne jen barvy/kvality. Zkouší od nejpřesnějšího
  // klíče po nejobecnější, ať funguje i u produktů bez rozlišení
  // velikosti/podtypu (stačí vyplnit jen to, co se skutečně liší).
  // Převede hodnotu barvy ze Shopify ("White and Black", "Dark Wood") na tvar
  // klíčů v mapě ("white-and-black", "dark-wood") + případné aliasy.
  function colorCandidates(raw) {
    // "White & Red" -> "white-and-red" (tak jsou barvy zapsané v UID Gelata)
    const norm = (raw || "").toLowerCase().trim().replace(/\s*&\s*/g, " and ").replace(/\s+/g, "-");
    if (!norm) return [""];
    const list = [norm];
    // Gelato píše americky "gray" a "sport-": "Sport-grey"/"Sports Grey" -> "sport-gray"
    const us = norm.replace(/grey/g, "gray").replace(/^sports-/, "sport-");
    if (us !== norm) list.push(us);
    // Shopify "Wood"/"Light Wood" = Gelato "natural-wood" (u starších klíčů "natural")
    if (norm === "wood" || norm === "light-wood") list.push("natural-wood", "natural");
    if (norm === "natural-wood") list.push("natural");
    return list;
  }

  function inchPairsFromText(text) {
    // Z textu velikosti vytáhne rozměry v PALCÍCH, podle jednotek, ne podle pořadí.
    // Zvládá: "8 x 12 palců (20,3 x 30,5 cm)", "30×45 cm / 12×18\"", "300 x 450 mm",
    // "18.00 × 24.00 inch". Bez jednotky zkusí palce a potom centimetry.
    const re = /(\d+(?:[.,]\d+)?)\s*[x×X]\s*(\d+(?:[.,]\d+)?)\s*(mm|cm|inch(?:es)?|in\b|palc(?:ů|u|e)|["″”])?/gi;
    const found = [];
    let m;
    while ((m = re.exec(String(text || "")))) {
      found.push({ a: parseFloat(m[1].replace(",", ".")), b: parseFloat(m[2].replace(",", ".")), unit: (m[3] || "").toLowerCase() });
    }
    const toIn = (v, mmPerUnit) => Math.round(v * mmPerUnit / 25.4);
    const out = [];
    const push = (w, h) => { if (!out.some(p => p[0] === w && p[1] === h)) out.push([w, h]); };
    for (const f of found) if (/^(inch|inches|in|palců|palcu|palce|"|″|”)$/.test(f.unit)) push(Math.round(f.a), Math.round(f.b));
    for (const f of found) { if (f.unit === "mm") push(toIn(f.a, 1), toIn(f.b, 1)); else if (f.unit === "cm") push(toIn(f.a, 10), toIn(f.b, 10)); }
    for (const f of found) if (!f.unit) { push(Math.round(f.a), Math.round(f.b)); push(toIn(f.a, 10), toIn(f.b, 10)); }
    return out;
  }

  // Převede velikost ze Shopify na kanonický tvar klíčů v mapě ("18x24", "12x18", "M").
  // Vrací seznam kandidátů podle priority (u nejasných zápisů víc možností).
  function sizeCandidates(raw) {
    const s = (raw || "").trim();
    if (!s) return [""];
    const pairs = inchPairsFromText(s);
    if (pairs.length) {
      const list = [];
      for (const [w, h] of pairs) {
        const canon = `${w}x${h}`;
        if (!list.includes(canon)) list.push(canon);
        if (canon === "8x12" && !list.includes("A4")) list.push("A4"); // v mapě je 8x12" vedené i jako "A4"
      }
      return list;
    }
    return [s.toUpperCase()];
  }


  // Tloušťka rámu u obrazů na plátně ("Thickness": Slim / Thick). Bez tohohle
  // by se pro Thick použilo UID pro Slim = zákazníkovi by přišel jiný produkt.
  function getSelectedThickness() {
    if (state.variantOptions && state.variantOptions.thickness) return state.variantOptions.thickness.toLowerCase();
    const el = document.querySelector('input[name*="Thickness"]:checked, select[name*="Thickness"]');
    return (el?.value || "").toLowerCase();
  }

  // Volba strany (Front/Back, "Strana") jako SKUTEČNÁ varianta produktu. Čteme ji
  // z dat produktu ve Shopify (ne z formuláře), aby se nespletla s pouhým
  // přepínačem pohledu na mockup. Naše UID jsou jen pro přední tisk, takže "Back"
  // musí skončit bez UID (= koupě se zablokuje), dokud nemáme UID pro zadní stranu.
  let productJsonPromise = null;
  function getProductJson() {
    if (!productJsonPromise) {
      productJsonPromise = fetch(location.pathname.split("?")[0] + ".js")
        .then(r => (r.ok ? r.json() : null)).catch(() => null);
    }
    return productJsonPromise;
  }
  // Volby AKTUÁLNĚ vybrané varianty přímo z dat produktu ve Shopify. Nezávisí na
  // tom, jak šablona pojmenuje pole formuláře ("Color", "Frame color", "Barva
  // rámu", "Velikost"...). Vrací { color, size, thickness, side } nebo null.
  async function getSelectedVariantOptions() {
    try {
      const pj = await getProductJson();
      if (!pj || !pj.options || !pj.variants) return null;
      const names = pj.options.map(o => (typeof o === "string" ? o : (o && o.name) || ""));
      const idEl  = document.querySelector('form[action*="/cart/add"] [name="id"]');
      const vid   = Number((idEl && idEl.value) || new URL(location.href).searchParams.get("variant"));
      const v = pj.variants.find(x => Number(x.id) === vid) || (pj.variants.length === 1 ? pj.variants[0] : null);
      if (!v) return null;
      const pick = re => { const i = names.findIndex(n => re.test(n)); return i >= 0 ? String(v["option" + (i + 1)] || "") : ""; };
      return {
        color:     pick(/colou?r|barva|^frame$|rám/i),
        size:      pick(/size|velikost|rozměr|format|formát/i),
        thickness: pick(/thickness|tloušťka/i),
        side:      pick(/^(side|strana)$/i),
      };
    } catch (_) { return null; }
  }

  // Diagnostika pro majitele obchodu: na stránce produktu napiš do konzole
  //   LF_CHECK_VARIANTS()
  // Projde VŠECHNY varianty produktu a u každé řekne, jestli má UID (= jde vyrobit).
  // Nic negeneruje ani neobjednává.
  async function checkAllVariants() {
    const pj = await getProductJson();
    if (!pj || !pj.variants) { console.log("Nejsem na stránce produktu (nelze načíst data produktu)."); return; }
    const names = pj.options.map(o => (typeof o === "string" ? o : (o && o.name) || ""));
    console.log("PRODUKT:", pj.title, "| handle:", pj.handle);
    console.log("TAGY:", JSON.stringify(state.productTags));
    console.log("STYL:", state.styleTag || "NEROZPOZNÁN", "| TYP:", state.productType || "NEROZPOZNÁN (chybí tag product_*)");
    console.log("VOLBY PRODUKTU:", JSON.stringify(names));
    if (!state.productType) return;
    let bad = 0;
    for (const v of pj.variants) {
      const pick = re => { const i = names.findIndex(n => re.test(n)); return i >= 0 ? String(v["option" + (i + 1)] || "") : ""; };
      const color = pick(/colou?r|barva|^frame$|rám/i), size = pick(/size|velikost|rozměr|format|formát/i);
      const thick = pick(/thickness|tloušťka/i), side = pick(/^(side|strana)$/i);
      let tag = state.productType;
      if (/thick/i.test(thick) && !/slim/i.test(thick)) tag += "_thick";
      if (/back|zad/i.test(side)) tag += "_back";
      const uid = await resolveGelatoUid(tag, color, pj.handle, size);
      if (uid) console.log("✅", v.title);
      else { bad++; console.log("❌", v.title, "| hledáno: typ", tag, "| barva", color || "-", "| velikost", size || "-"); }
    }
    console.log(bad ? `VÝSLEDEK: ${bad} z ${pj.variants.length} variant nemá UID (nejde vyrobit)` : `VÝSLEDEK: všech ${pj.variants.length} variant má UID`);
  }
  window.LF_CHECK_VARIANTS = checkAllVariants;

  async function getSelectedSide() {
    try {
      const pj = await getProductJson();
      if (!pj || !pj.options) return "";
      const idx = pj.options.findIndex(o => /^(side|strana)$/i.test(typeof o === "string" ? o : (o && o.name) || ""));
      if (idx < 0) return ""; // produkt nemá volbu strany
      const idEl = document.querySelector('form[action*="/cart/add"] [name="id"]');
      const vid  = Number((idEl && idEl.value) || new URL(location.href).searchParams.get("variant"));
      const v = (pj.variants || []).find(x => Number(x.id) === vid);
      return String((v && v["option" + (idx + 1)]) || "").toLowerCase();
    } catch (_) { return ""; }
  }

  async function resolveGelatoUid(productTypeTag, colorOverride, handleOverride, sizeOverride) {
    const map = await getGelatoMap();
    // Tloušťku čteme jen pro produkt na aktuální stránce (ne pro cross-sell,
    // který předává vlastní handle). Thick má vlastní tag, zatím bez UID.
    const thickness = handleOverride ? "" : String(getSelectedThickness() || "").toLowerCase();
    let tag = (/thick/.test(thickness) && !/slim/.test(thickness)) ? `${productTypeTag}_thick` : productTypeTag;
    // Zadní strana má vlastní tag (zatím bez UID, dokud je Gelato nepotvrdí)
    const side = handleOverride ? "" : await getSelectedSide();
    if (/back|zad/.test(side)) tag = `${tag}_back`;
    const colors  = colorCandidates(colorOverride || getSelectedColor());
    const sizes   = sizeCandidates(sizeOverride   || getSelectedSize());
    const guess   = guessProductSubtype(handleOverride || state.productHandle || "");
    // Když se podtyp nepodaří poznat z handle, zkusíme všechny známé
    // (trika/mikiny/raglan v mapě jsou classic/premium bez ohledu na handle).
    const subtypes = guess ? [guess] : ["", "classic", "premium"];

    const key = (...parts) => [tag, ...parts.filter(Boolean)].join(":");
    const candidates = new Set();
    for (const sub of subtypes) for (const z of sizes) for (const c of colors) candidates.add(key(sub, z, c));
    for (const sub of subtypes) for (const c of colors) candidates.add(key(sub, c));
    for (const sub of subtypes) for (const z of sizes) candidates.add(key(sub, z));
    for (const z of sizes) for (const c of colors) candidates.add(key(z, c));
    for (const z of sizes) candidates.add(key(z));
    for (const c of colors) candidates.add(key(c));
    for (const sub of subtypes) candidates.add(key(sub));
    candidates.add(tag);

    for (const k of candidates) {
      if (map[k]) return map[k];
    }
    // Produkt BEZ volby barvy (např. kovový rám jen v černé): klíče v mapě barvu
    // obsahují ("...:12x18:black"). Když pro danou velikost existuje PRÁVĚ JEDNA
    // barva, je jednoznačná. Při víc barvách se nehádá (UID zůstane prázdné).
    if (!colors[0]) {
      for (const sub of ["", ...subtypes]) for (const z of sizes) { // i bez podtypu (klíče rámů ho nemají)
        if (!z) continue;
        const prefix = key(sub, z) + ":";
        const matches = Object.keys(map).filter(k => k.startsWith(prefix));
        if (matches.length === 1) return map[matches[0]];
      }
    }
    console.warn(`[LF] Žádné UID pro ${tag} (barva: ${colors[0]}, velikost: ${sizes[0]})`);
    return "";
  }

  // Odvodí podtyp produktu (classic/premium/...) z handle - např.
  // "classic-tote-bag-1" -> "classic", "premium-tote-bag-3" -> "premium".
  // Umožňuje rozlišit fyzicky odlišné Gelato produkty bez nutnosti dalšího
  // ručního tagování v Shopify.
  function guessProductSubtype(handle) {
    const h = (handle || "").toLowerCase();
    if (h.includes("premium")) return "premium";
    if (h.includes("classic"))  return "classic";
    if (h.includes("deluxe"))   return "deluxe";
    return "";
  }

  function getSelectedColor() {
    // Hledá vybranou barvu v produktovém formuláři - běžné konvence Shopify
    // motivů: input/select s name obsahujícím "Color", nebo aria-label.
    if (state.variantOptions && state.variantOptions.color) return state.variantOptions.color;
    const colorInput = document.querySelector(
      'input[name*="Color"]:checked, select[name*="Color"], input[name="Barva"]:checked'
    );
    return colorInput?.value || "";
  }

  function getSelectedSize() {
    // Hledá vybranou velikost v produktovém formuláři - stejná konvence jako
    // u barvy, jen pro "Size"/"Velikost".
    if (state.variantOptions && state.variantOptions.size) return state.variantOptions.size;
    const sizeInput = document.querySelector(
      'input[name*="Size"]:checked, select[name*="Size"], input[name="Velikost"]:checked'
    );
    return sizeInput?.value || "";
  }

  // Odvodí skutečný poměr stran (šířka/výška) přímo z čísel v názvu vybrané
  // velikosti (např. "12x18" -> 12/18, "18x24" -> 18/24) - funguje automaticky
  // pro JAKOUKOLIV velikost bez nutnosti ručně dopisovat poměry do kódu.
  // "A4" je speciální případ (v tomhle katalogu odpovídá 8x12", ne ISO 210x297mm).
  function deriveRatioFromSize(sizeLabel) {
    if (!sizeLabel) return null;
    const s = sizeLabel.trim().toUpperCase();
    if (s === "A4") return 8 / 12;
    const match = s.match(/(\d+(?:\.\d+)?)\s*[X×]\s*(\d+(?:\.\d+)?)/);
    if (match) {
      const w = parseFloat(match[1]);
      const h = parseFloat(match[2]);
      if (w > 0 && h > 0) return w / h;
    }
    return null;
  }

  // Vrátí poměr stran, který se má použít PRÁVĚ TEĎ - podle aktuálně vybrané
  // velikosti (pokud jde rozeznat), jinak fallback na výchozí konfiguraci typu
  // produktu. Volej vždy čerstvě (ne jednou při načtení), ať reaguje na změnu
  // velikosti ve variantách.
  function getEffectiveRatio() {
    const derived = deriveRatioFromSize(getSelectedSize());
    return derived || state.productConfig?.ratio || 1;
  }

  // ZÁLOŽNÍ ROZPOZNÁVÁNÍ: ne všechny produkty mají tag s prefixem "product_"
  // (např. plakát má jen holý tag "poster", ne "product_poster"). Tahle mapa
  // umožňuje rozeznat typ i z holého slova - funguje pro OBECNÉ chování
  // (zachování pozadí, přibližný poměr stran), ale NEDÁVÁ dost přesnosti pro
  // Gelato UID mapu (ta potřebuje vědět přesnou gramáž/rám/velikost) - pro
  // plnou funkčnost tisku bude nutné časem doplnit specifičtější tag.
  const BARE_TAG_FALLBACK = {
    poster:   "product_poster",
    plakat:   "product_poster",
    canvas:   "product_canvas",
    obraz:    "product_canvas",
    zaramovany: "product_canvas_framed",
    bag:      "product_bag",
    taska:    "product_bag",
    tshirt:   "product_tshirt",
    tricko:   "product_tshirt",
    hoodie:   "product_hoodie",
    mikina:   "product_hoodie",
    cap:      "product_cap",
    cepice:   "product_cap",
    calendar: "product_calendar",
    kalendar: "product_calendar",
  };

  function resolveProductTypeTag(tags) {
    const prefixed = tags.find(t => t.startsWith("product_"));
    // Zpětná kompatibilita: starý tag (jen klasická 170gsm řada měla bílou)
    const LEGACY_TAG_ALIASES = { product_poster_hanging: "product_poster_hanging_classic" };
    if (prefixed) return LEGACY_TAG_ALIASES[prefixed] || prefixed;
    // Zkus holé slovo (case-insensitive, bez diakritiky nezáleží - klíče jsou už bez ní)
    for (const tag of tags) {
      const key = tag.toLowerCase().trim();
      if (BARE_TAG_FALLBACK[key]) return BARE_TAG_FALLBACK[key];
    }
    return null;
  }

  // Stejný problém jako u typu produktu - i STYLOVÉ tagy někdy chybí prefix
  // "style_" (např. "cyber-punk"/"cyberpunk" místo "style_cyberpunk").
  const STYLE_BARE_TAG_FALLBACK = {
    "yellowtown":  "style_yellowtown",
    "zluta-ves":   "style_yellowtown",
    "anime":       "style_anime",
    "comics":      "style_comics",
    "komiks":      "style_comics",
    "popart":      "style_popart",
    "pop-art":     "style_popart",
    "oilpainting": "style_oilpainting",
    "olejomalba":  "style_oilpainting",
    "cyberpunk":   "style_cyberpunk",
    "cyber-punk":  "style_cyberpunk",
    "watercolor":  "style_watercolor",
    "akvarel":     "style_watercolor",
  };

  function resolveStyleTag(tags) {
    const prefixed = tags.find(t => t.startsWith("style_"));
    if (prefixed) return prefixed;
    for (const tag of tags) {
      const key = tag.toLowerCase().trim();
      if (STYLE_BARE_TAG_FALLBACK[key]) return STYLE_BARE_TAG_FALLBACK[key];
    }
    return null;
  }

  async function init() {
    state.styleTag     = resolveStyleTag(state.productTags);
    const productTag   = resolveProductTypeTag(state.productTags);
    state.productType  = productTag;
    state.productConfig = PRODUCT_TYPES[productTag] || PRODUCT_TYPES["product_tshirt"];

    if (!state.styleTag) return;
    if (!productTag) {
      console.warn("[LF] Produkt má styl, ale NEMÁ tag typu produktu (product_*), takže nejde zjistit UID a koupě bude zablokovaná. Tagy produktu:", state.productTags);
    }

    // window._lf.gelatoUid se ukázal jako nespolehlivý. Místo něj dohledáme
    // UID podle typu produktu + aktuálně vybrané barvy - přepočítá se znovu
    // i při změně varianty (viz bindVariantChangeListener), ať se nepoužije
    // špatné UID, pokud zákazník barvu po načtení stránky přepne.
    if (!state.gelatoUid && productTag) {
      state.variantOptions = await getSelectedVariantOptions();
      state.gelatoUid = await resolveGelatoUid(productTag);
      if (!state.gelatoUid) {
        console.warn(`[LF] Chybí gelatoUid pro "${productTag}:${getSelectedColor()}" v GELATO_UID_MAP (worker.js).`);
      }
    }
    state.uidChecked = true; // UID pro vybranou variantu je zjištěné (viz getCartBlockReason)
    updateUidNotice();

    injectWidget();
    await loadCreditStatus();
    await tryLoadFromCrossSellLink();
  }

  // ════════════════════════════════════════════════════════════════
  // WIDGET HTML
  // ════════════════════════════════════════════════════════════════
  function injectWidget() {
    const anchor =
      document.querySelector(".product-form__buttons") ||
      document.querySelector(".product-form__submit") ||
      document.querySelector('[name="add"]')?.parentElement ||
      document.querySelector("form[action*='/cart/add']");

    if (!anchor) return;

    const wrapper = document.createElement("div");
    wrapper.id    = "lf-widget";
    anchor.insertAdjacentElement("afterend", wrapper);

    wrapper.innerHTML = `
      <div class="lf-inner">
        <div class="lf-header">
          <h3 class="lf-title">🎨 Personalizuj</h3>
          <div id="lf-badge" class="lf-badge"></div>
        </div>

        <!-- KROK 1: Upload -->
        <p id="lf-uid-notice-pre" class="lf-cart-hint" style="display:none; color:#b91c1c; margin-bottom:12px;">⛔ Tuto variantu (barvu nebo velikost) zatím neumíme vyrobit. Vyber prosím jinou variantu, než začneš generovat.</p>
        <div id="lf-step-upload" class="lf-step lf-step--active">
          <div class="lf-upload-zone" id="lf-upload-zone">
            <input type="file" id="lf-file-input" accept="image/*" style="display:none">
            <div class="lf-upload-icon">📸</div>
            <p class="lf-upload-text">Nahrajte vaši fotku</p>
            <p class="lf-upload-sub">JPG nebo PNG – min. 800×800px</p>
            <button type="button" class="lf-btn lf-btn--outline" id="lf-upload-btn">Vybrat fotku</button>
          </div>
        </div>

        <!-- KROK 2: Ořez -->
        <div id="lf-step-crop" class="lf-step">
          <p class="lf-step-label">Upravte výřez (tažením posunete, posuvníkem přiblížíte):</p>
          <div class="lf-crop-outer">
            <div id="lf-crop-viewport" class="lf-crop-viewport">
              <img id="lf-crop-img" class="lf-crop-img" draggable="false" alt="Náhled ořezu">
            </div>
          </div>
          <label class="lf-slider-label">Přiblížení: <input type="range" id="lf-crop-zoom" min="0" max="100" value="0"></label>
          <div class="lf-actions">
            <button type="button" class="lf-btn lf-btn--outline" id="lf-btn-back">← Zpět</button>
            <button type="button" class="lf-btn lf-btn--primary" id="lf-btn-generate">✨ Generovat</button>
          </div>
        </div>

        <!-- KROK 3: Generování -->
        <div id="lf-step-generating" class="lf-step">
          <div class="lf-generating">
            <div class="lf-spinner"></div>
            <p class="lf-gen-text" id="lf-gen-text">Generuji váš obrázek...</p>
            <p class="lf-gen-sub" id="lf-gen-timer">0 s</p>
          </div>
        </div>

        <!-- KROK 4: Výsledek -->
        <div id="lf-step-result" class="lf-step">
          <p class="lf-step-label">Náhled:</p>
          <div class="lf-preview-wrap">
            <div class="lf-mockup-container" id="lf-mockup-container">
              <img id="lf-mockup-img" class="lf-mockup-img" src="" alt="Mockup produktu">
              <div class="lf-generated-overlay" id="lf-generated-overlay">
                <img id="lf-generated-img" class="lf-generated-img" src="" alt="Vygenerovaný obrázek">
              </div>
            </div>
          </div>
          <label class="lf-slider-label">Velikost: <input type="range" id="lf-mockup-size" min="60" max="400" value="100"></label>
          <div class="lf-actions">
            <button type="button" class="lf-btn lf-btn--outline" id="lf-btn-reset">🔄 Znovu</button>
          </div>
          <p class="lf-cart-hint">✓ Personalizace je připravená – použij tlačítko "Přidat do košíku" výše na stránce.</p>
          <p id="lf-uid-notice" class="lf-cart-hint" style="display:none; color:#b91c1c;">⛔ Tento produkt nebo varianta zatím nejde vyrobit. Zkus prosím jinou variantu, případně nám napiš.</p>
          <p id="lf-ratio-notice" class="lf-cart-hint" style="display:none; color:#b45309;">⚠️ Změnil jsi velikost nebo orientaci. Obrázek byl vytvořen pro jiný tvar plochy – pro nejlepší výsledek klikni na „Znovu“ a vygeneruj ho znovu.</p>

          <button type="button" class="lf-btn lf-btn--outline lf-download-btn" id="lf-btn-download" style="display:none; width:100%; margin-top:10px;">
            ⬇️ Stáhnout v tiskové kvalitě
          </button>

          <div id="lf-crosssell" class="lf-crosssell"></div>
        </div>

        <!-- Modal -->
        <div id="lf-modal" class="lf-modal">
          <div class="lf-modal-backdrop" id="lf-modal-backdrop"></div>
          <div class="lf-modal-box">
            <button type="button" class="lf-modal-close" id="lf-modal-close">✕</button>
            <div id="lf-modal-icon" class="lf-modal-icon">⏳</div>
            <h3 id="lf-modal-title" class="lf-modal-title"></h3>
            <p id="lf-modal-body" class="lf-modal-body"></p>
            <div class="lf-modal-btns">
              <button type="button" class="lf-btn lf-btn--primary" id="lf-modal-buy">🛒 Koupit kredity</button>
              <a class="lf-btn lf-btn--outline" href="${REGISTER_URL}" id="lf-modal-register">Zaregistrovat se zdarma</a>
            </div>
            <p class="lf-modal-note">Kredity jsou připsány okamžitě po zaplacení</p>
          </div>
        </div>
      </div>
    `;

    injectStyles();
    bindEvents();
    loadMockupImage();
  }

  // ════════════════════════════════════════════════════════════════
  // EVENTY
  // ════════════════════════════════════════════════════════════════
  function bindEvents() {
    // Upload
    document.getElementById("lf-upload-btn").addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      document.getElementById("lf-file-input").click();
    });

    document.getElementById("lf-file-input").addEventListener("change", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const file = e.target.files[0];
      if (file) handleFile(file);
    });

    // Drag & drop
    const zone = document.getElementById("lf-upload-zone");
    zone.addEventListener("dragover",  (e) => { e.preventDefault(); zone.classList.add("lf-upload-zone--drag"); });
    zone.addEventListener("dragleave", ()  => zone.classList.remove("lf-upload-zone--drag"));
    zone.addEventListener("drop",      (e) => {
      e.preventDefault();
      zone.classList.remove("lf-upload-zone--drag");
      const file = e.dataTransfer.files[0];
      if (file) handleFile(file);
    });

    // Tlačítka
    document.getElementById("lf-btn-back").addEventListener("click",     (e) => { e.preventDefault(); lfReset(); });
    document.getElementById("lf-btn-generate").addEventListener("click", (e) => { e.preventDefault(); lfGenerate(); });
    document.getElementById("lf-btn-reset").addEventListener("click",    (e) => { e.preventDefault(); lfReset(); });
    document.getElementById("lf-btn-download").addEventListener("click", (e) => { e.preventDefault(); lfDownloadPrintQuality(); });

    // Sledování změny varianty (barva/velikost) - aktualizuj mockup fotku,
    // ať odpovídá zákazníkem vybrané barvě, ne pořád stejné výchozí.
    bindVariantChangeListener();
    bindCartGuard();

    // Doladění velikosti vygenerovaného obrázku na mockupu
    document.getElementById("lf-mockup-size").addEventListener("input", updateOverlay);

    // Tažení (drag) vygenerovaného obrázku po mockupu - posun v rámci plochy
    bindOverlayDrag();

    // Modal
    document.getElementById("lf-modal-backdrop").addEventListener("click", closeModal);
    document.getElementById("lf-modal-close").addEventListener("click",    closeModal);
    document.getElementById("lf-modal-buy").addEventListener("click", () => { window.location.href = BUY_URL; });
  }

  // ════════════════════════════════════════════════════════════════
  // MOCKUP IMAGE
  // ════════════════════════════════════════════════════════════════
  async function loadMockupImage() {
    const mockupEl = document.getElementById("lf-mockup-img");
    if (!mockupEl) return;

    // PRIORITA 1: veřejné Shopify products.json API podle handle produktu.
    // Nezávisí na žádné ruční Liquid úpravě šablony ani na hádání podle DOM -
    // konvence: 1. obrázek = vzorek se vzorem, 2. obrázek = čistý mockup.
    if (state.productHandle) {
      try {
        const res  = await fetch(`/products/${state.productHandle}.json`);
        const data = await res.json();
        state.productData = data.product || null; // uloženo pro přepínání barev/variant

        const images = data.product?.images || [];
        const idEl = document.querySelector('form[action*="/cart/add"] [name="id"], input[name="id"], select[name="id"]');
        const currentVariant = (idEl && idEl.value) || new URL(location.href).searchParams.get("variant");
        const mockupSrc = pickImageForVariant(state.productData, currentVariant) || images[1]?.src || images[0]?.src;
        if (mockupSrc) {
          mockupEl.style.display = "";
          mockupEl.src = mockupSrc;
          // KLÍČOVÁ OPRAVA: kontejner měl natvrdo aspect-ratio:1 (čtverec) bez
          // ohledu na skutečný tvar mockup fotky (ta bývá vyšší než širší).
          // To způsobovalo "obálkování" fotky uvnitř čtverce a naše procentuální
          // pozicování (printX/Y/W/H) pak sedělo na kontejner, ne na fotku
          // samotnou - proto vygenerovaný obrázek seděl špatně. Teď nastavíme
          // kontejneru SKUTEČNÝ poměr stran fotky, jakmile se načte.
          mockupEl.onload = () => {
            const container = document.getElementById("lf-mockup-container");
            if (container && mockupEl.naturalWidth && mockupEl.naturalHeight) {
              container.style.aspectRatio = `${mockupEl.naturalWidth} / ${mockupEl.naturalHeight}`;
            }
          };
          return;
        }
      } catch (err) {
        console.warn("[LF] Načtení mockupu přes products.json selhalo:", err.message);
      }
    }

    // PRIORITA 2: window._lf.productImage, pokud byl ručně nastavený v Liquid.
    const directImage = window._lf?.productImage;
    if (directImage) {
      mockupEl.style.display = "";
      mockupEl.src = directImage;
      return;
    }

    // PRIORITA 3 (poslední záchrana): hledání v DOM podle heuristiky.
    const allImgs = Array.from(document.querySelectorAll("img"));

    const productImg = allImgs.find(img => {
      if (!img.src) return false;
      if (img.src.startsWith("data:")) return false;
      if (!img.src.includes("cdn.shopify")) return false;
      if (img.src.includes("losfiltros_")) return false;
      if (img.naturalWidth < 50) return false;
      return true;
    });

    // FALLBACK: pokud se nenajde vhodný mockup obrázek, skryjeme mockup <img>
    // úplně (aby se nezobrazovala rozbitá ikona / prázdný alt text) a necháme
    // jen samotný vygenerovaný AI obrázek bez podkladu produktu na šedém pozadí.
    if (!productImg) {
      mockupEl.style.display = "none";
      const container = document.getElementById("lf-mockup-container");
      if (container) container.style.background = "#f0f0f0";
      const overlay = document.getElementById("lf-generated-overlay");
      if (overlay) {
        overlay.style.position = "static";
        overlay.style.left     = "0";
        overlay.style.top      = "0";
        overlay.style.width    = "100%";
        overlay.style.height   = "100%";
      }
      return;
    }

    mockupEl.style.display = "";
    mockupEl.src = productImg.src;
  }

  // Sleduje změnu vybrané varianty (barva/velikost) přes skryté pole "id" v
  // produktovém formuláři a aktualizuje mockup fotku podle featured_image
  // té konkrétní varianty (spolehlivější než hádat pořadí obrázků - Shopify
  // u každé varianty umožňuje mít vlastní přiřazenou fotku).
  let variantListenerBound = false;
  function bindVariantChangeListener() {
    if (variantListenerBound) return;
    variantListenerBound = true;

    // Záchytná síť: jakákoli změna výběru ve formuláři produktu (některé motivy
    // skryté pole "id" nepřepisují tak, aby to šlo spolehlivě sledovat).
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) productForm.addEventListener("change", scheduleVariantRefresh);

    const variantInput = document.querySelector('input[name="id"], select[name="id"]');
    if (!variantInput) return;

    const handler = () => updateMockupForVariant(variantInput.value);

    // Pokrývá jak <select> (change event), tak skryté <input> aktualizované
    // JS frameworkem motivu (sledujeme přes MutationObserver na value atribut).
    variantInput.addEventListener("change", handler);
    if (variantInput.tagName === "INPUT") {
      const observer = new MutationObserver(handler);
      observer.observe(variantInput, { attributes: true, attributeFilter: ["value"] });
      // Fallback: většina motivů mění .value přímo JS bez atributu - sleduj i tak periodicky málo nákladně přes 'input' event, pokud existuje
      variantInput.addEventListener("input", handler);
    }
  }

  // Po každé změně varianty (barva, velikost, tloušťka...) přepočítá UID a přepíše
  // ho i ve skrytých polích formuláře košíku. Dřív se UID zapsalo do formuláře
  // jen při vygenerování, takže po pozdější změně varianty šlo do objednávky
  // UID původní varianty = vytiskl by se jiný produkt, než zákazník koupil.
  let variantRefreshTimer = null;
  function scheduleVariantRefresh() {
    clearTimeout(variantRefreshTimer);
    // Dokud přepočet neskončí, UID neznáme jistě - košík se zatím nepustí
    // (viz getCartBlockReason).
    state.uidChecked = false;
    variantRefreshTimer = setTimeout(async () => {
      if (!state.productType) { state.uidChecked = true; return; }
      state.variantOptions = await getSelectedVariantOptions();
      let uid = "";
      try { uid = await resolveGelatoUid(state.productType); }
      catch (e) { console.warn("[LF] Zjištění UID selhalo:", e); }
      // I PRÁZDNÉ UID se musí přepsat. Staré UID u jiné varianty by znamenalo
      // špatný produkt; bez UID se koupě zablokuje a nic se nezaplatí zbytečně.
      state.gelatoUid = uid;
      state.uidChecked = true;
      if (state.previewUrl) injectPropertiesIntoNativeForm();
      notifyIfRatioChanged();
      updateUidNotice();
    }, 150);
  }

  // Proč by se teď nemělo dát přidat do košíku (nebo null = v pořádku).
  // Řeší situaci, kdy by zákazník zaplatil za motiv, který se nedá vytisknout:
  // varianta bez UID, UID se ještě zjišťuje, nebo soubor k tisku není nahraný.
  // Když zákazník nic nevytvořil, neblokuje se nic.
  function getCartBlockReason(s = state) {
    if (!s.generatedImage) return null;
    // Widget je aktivní (produkt má styl), ale chybí tag typu produktu: UID by se
    // nikdy nezjistilo a zákazník by zaplatil za něco, co nejde vytisknout.
    if (!s.productType) return "Tento produkt zatím nemá nastavený tisk, takže by ho nešlo vyrobit. Napiš nám prosím, ať to opravíme.";
    if (!s.uidChecked) return "Ještě se ověřuje vybraná varianta, zkus to za okamžik.";
    if (!s.gelatoUid) return "Pro tuto kombinaci barvy nebo velikosti zatím neumíme zajistit tisk. Vyber prosím jinou variantu.";
    if (!s.previewUrl) return "Soubor k tisku se ještě připravuje. Počkej chvilku, případně klikni na „Znovu“.";
    return null;
  }

  // Proč nepustit generování (null = v pořádku). Když se UID teprve zjišťuje,
  // generování se nebrzdí - kontrola proběhne znovu před košíkem.
  function getGenerateBlockReason(s = state) {
    if (!s.productType) return "Tento produkt zatím nemá nastavený tisk, takže by ho nešlo vyrobit. Generování jsem zastavil, aby se zbytečně nespotřeboval kredit.";
    if (s.uidChecked && !s.gelatoUid) return "Tuto variantu (barvu nebo velikost) zatím neumíme vyrobit. Vyber prosím jinou variantu. Generování jsem zastavil, aby se zbytečně nespotřeboval kredit.";
    return null;
  }

  function updateUidNotice() {
    const cannot = !state.productType || (state.uidChecked && !state.gelatoUid);
    const el  = document.getElementById("lf-uid-notice");
    const pre = document.getElementById("lf-uid-notice-pre");
    if (el)  el.style.display  = (state.generatedImage && cannot) ? "block" : "none";
    if (pre) pre.style.display = (!state.generatedImage && cannot) ? "block" : "none";
  }

  // Zachytí kliknutí na "Přidat do košíku" i odeslání formuláře DŘÍV než skripty
  // motivu (capture) a při důvodu k zablokování koupi zastaví. Při jakékoli chybě
  // pojistky se nákup NEblokuje (pojistka nesmí zavřít obchod).
  let cartGuardBound = false;
  function bindCartGuard() {
    if (cartGuardBound) return;
    cartGuardBound = true;
    const SEL = 'form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"], form[action*="/cart/add"] button[name="add"]';
    const guard = (e) => {
      try {
        if (e.type === "click") {
          const btn = e.target && e.target.closest ? e.target.closest(SEL) : null;
          if (!btn) return;
        } else if (e.type === "submit") {
          const f = e.target;
          if (!(f && f.matches && f.matches('form[action*="/cart/add"]'))) return;
        } else return;
        const reason = getCartBlockReason();
        if (!reason) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        alert(reason);
      } catch (err) {
        console.warn("[LF] Pojistka košíku selhala, nákup neblokuji:", err);
      }
    };
    document.addEventListener("click", guard, true);
    document.addEventListener("submit", guard, true);
  }

  // Když se po vygenerování změní tvar plochy (např. 12x18 -> 18x12), obrázek
  // už neodpovídá - upozorni zákazníka, ať ho vytvoří znovu.
  function notifyIfRatioChanged() {
    const el = document.getElementById("lf-ratio-notice");
    if (!el) return;
    if (!state.generatedImage || !state.generatedRatio) { el.style.display = "none"; return; }
    const now = getEffectiveRatio();
    const changed = now && Math.abs(now - state.generatedRatio) / state.generatedRatio > 0.03;
    el.style.display = changed ? "block" : "none";
  }

  // Fotka pro vybranou variantu:
  //  1) fotka přiřazená variantě ve Shopify (featured_image),
  //  2) fotka, jejíž popisek (alt) nebo název souboru obsahuje název barvy,
  //  3) nic (null) - volající nechá výchozí fotku.
  function pickImageForVariant(product, variantId) {
    if (!product || !variantId) return null;
    const variant = (product.variants || []).find(v => String(v.id) === String(variantId));
    if (!variant) return null;
    if (variant.featured_image?.src) return variant.featured_image.src;
    if (variant.image_id) {
      const byId = (product.images || []).find(i => String(i.id) === String(variant.image_id));
      if (byId?.src) return byId.src;
    }
    const names = (product.options || []).map(o => (typeof o === "string" ? o : (o && o.name) || ""));
    const ci = names.findIndex(n => /colou?r|barva/i.test(n));
    const color = ci >= 0 ? String(variant["option" + (ci + 1)] || "") : "";
    if (!color) return null;
    const norm = s => String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
    const c = norm(color);
    if (!c) return null;
    const tokRe = t => new RegExp(`(^|-)${t}(-|$)`);
    // Delší barvy obsahující tuto (např. "light-blue" pro "blue") - jejich fotky vyřadit
    const longer = [...new Set((product.variants || []).map(v => norm(v["option" + (ci + 1)])))]
      .filter(o => o && o !== c && tokRe(c).test(o));
    const hit = (product.images || []).find(i => {
      const file = norm(decodeURIComponent(String(i.src || "").split("/").pop().split("?")[0]).replace(/\.[a-z0-9]+$/i, ""));
      const texts = [norm(i.alt), file];
      if (texts.some(t => longer.some(o => tokRe(o).test(t)))) return false;
      return texts.some(t => tokRe(c).test(t));
    });
    if (hit?.src) return hit.src;

    // Podle POŘADÍ: barvy v pořadí, v jakém jsou ve variantách (černá, modrá,
    // červená, bílá...), a fotky barev ve stejném pořadí. Fotky barev jsou
    // POSLEDNÍCH N fotek produktu (N = počet barev) - fotky navíc na začátku
    // (ukázka s motivem apod.) se přeskočí.
    const colorsInOrder = [];
    for (const v of product.variants || []) {
      const val = norm(v["option" + (ci + 1)]);
      if (val && !colorsInOrder.includes(val)) colorsInOrder.push(val);
    }
    const imgs = product.images || [];
    if (colorsInOrder.length > 1 && imgs.length >= colorsInOrder.length) {
      const idx = colorsInOrder.indexOf(c);
      const offset = imgs.length - colorsInOrder.length;
      if (idx >= 0 && imgs[offset + idx]?.src) return imgs[offset + idx].src;
    }
    return null;
  }

  function setMockupSrc(src) {
    const mockupEl = document.getElementById("lf-mockup-img");
    if (!mockupEl || !src) return;
    mockupEl.style.display = "";
    mockupEl.onload = () => {
      const container = document.getElementById("lf-mockup-container");
      if (container && mockupEl.naturalWidth && mockupEl.naturalHeight) {
        container.style.aspectRatio = `${mockupEl.naturalWidth} / ${mockupEl.naturalHeight}`;
      }
    };
    if (mockupEl.src !== src) mockupEl.src = src;
  }

  async function updateMockupForVariant(variantId) {
    const mockupEl = document.getElementById("lf-mockup-img");
    const product  = state.productData;
    if (!mockupEl || !product || !variantId) return;

    const variantImageSrc = pickImageForVariant(product, variantId);
    if (variantImageSrc) setMockupSrc(variantImageSrc);
    // Pokud varianta nemá vlastní featured_image, necháme zobrazený obrázek
    // beze změny (lepší než skočit na náhodný fallback).

    // Přepočítej gelatoUid i hodnotu ve formuláři košíku (viz scheduleVariantRefresh)
    scheduleVariantRefresh();
  }

  // ════════════════════════════════════════════════════════════════
  // FILE & VLASTNÍ CROP (bez externí knihovny)
  // ════════════════════════════════════════════════════════════════
  function handleFile(file) {
    if (!file.type.startsWith("image/")) {
      alert("Prosím nahrajte obrázek (JPG nebo PNG).");
      return;
    }
    const reader  = new FileReader();
    reader.onload = (e) => {
      state.originalImageDataUrl = e.target.result;
      initCustomCropper(e.target.result);
    };
    reader.readAsDataURL(file);
  }

  let cropEventsBound = false;

  function initCustomCropper(dataUrl) {
    showStep("crop");

    const viewport    = document.getElementById("lf-crop-viewport");
    const imgEl       = document.getElementById("lf-crop-img");
    const zoomSlider  = document.getElementById("lf-crop-zoom");
    const generateBtn = document.getElementById("lf-btn-generate");

    const ratio = getEffectiveRatio();
    // Responzivní šířka: na úzkých mobilech (i po odečtení paddingu widgetu)
    // nesmí přetéct mimo obrazovku. 280px je strop pro desktop.
    const inner = document.querySelector(".lf-inner");
    const available = inner ? inner.clientWidth - 8 : 280;
    const vw = Math.max(200, Math.min(280, available));
    const vh = Math.round(vw / ratio);
    viewport.style.width    = vw + "px";
    viewport.style.height   = vh + "px";
    viewport.style.maxWidth = "100%";

    if (generateBtn) generateBtn.disabled = true;
    zoomSlider.value = 0;

    const img = new Image();
    img.onload = () => {
      const coverScale   = Math.max(vw / img.naturalWidth, vh / img.naturalHeight);
      // "contain" - fotka se CELÁ vejde do výřezu (může být prázdný okraj),
      // na rozdíl od coverScale (vyplní celý výřez, ořízne přesahující část).
      // VÝCHOZÍ stav je teď contain, ať se širokoúhlé fotky do úzkého výřezu
      // (např. na trika) automaticky drasticky nepřiblíží - zákazník si pak
      // sám doladí přiblížení, pokud chce.
      const containScale = Math.min(vw / img.naturalWidth, vh / img.naturalHeight);
      state.crop = {
        naturalWidth:  img.naturalWidth,
        naturalHeight: img.naturalHeight,
        coverScale,
        containScale,
        scale:   containScale,
        offsetX: (vw - img.naturalWidth  * containScale) / 2,
        offsetY: (vh - img.naturalHeight * containScale) / 2,
        viewportW: vw,
        viewportH: vh,
      };
      imgEl.src = dataUrl;
      applyCropTransform();
      if (generateBtn) generateBtn.disabled = false;
    };
    img.onerror = () => {
      alert("Nepodařilo se načíst obrázek, zkuste to prosím znovu.");
      showStep("upload");
    };
    img.src = dataUrl;

    bindCropEvents(viewport, zoomSlider);
  }

  function applyCropTransform() {
    const imgEl = document.getElementById("lf-crop-img");
    const c = state.crop;
    if (!imgEl || !c) return;
    imgEl.style.width     = (c.naturalWidth  * c.scale) + "px";
    imgEl.style.height    = (c.naturalHeight * c.scale) + "px";
    imgEl.style.transform = `translate(${c.offsetX}px, ${c.offsetY}px)`;
  }

  function clampCropOffsets() {
    const c = state.crop;
    if (!c) return;
    const imgW = c.naturalWidth  * c.scale;
    const imgH = c.naturalHeight * c.scale;
    const minX = Math.min(0, c.viewportW - imgW);
    const minY = Math.min(0, c.viewportH - imgH);
    c.offsetX = Math.max(minX, Math.min(0, c.offsetX));
    c.offsetY = Math.max(minY, Math.min(0, c.offsetY));
  }

  function bindCropEvents(viewport, zoomSlider) {
    if (cropEventsBound) return; // event listeny stačí navázat jednou, čtou live state.crop
    cropEventsBound = true;

    let dragStart = null;

    viewport.addEventListener("pointerdown", (e) => {
      if (!state.crop) return;
      dragStart = { x: e.clientX, y: e.clientY, offsetX: state.crop.offsetX, offsetY: state.crop.offsetY };
      viewport.setPointerCapture(e.pointerId);
      viewport.classList.add("lf-crop-viewport--dragging");
    });

    viewport.addEventListener("pointermove", (e) => {
      if (!dragStart || !state.crop) return;
      state.crop.offsetX = dragStart.offsetX + (e.clientX - dragStart.x);
      state.crop.offsetY = dragStart.offsetY + (e.clientY - dragStart.y);
      clampCropOffsets();
      applyCropTransform();
    });

    const endDrag = () => {
      dragStart = null;
      viewport.classList.remove("lf-crop-viewport--dragging");
    };
    viewport.addEventListener("pointerup",     endDrag);
    viewport.addEventListener("pointerleave",  endDrag);
    viewport.addEventListener("pointercancel", endDrag);

    zoomSlider.addEventListener("input", () => {
      const c = state.crop;
      if (!c) return;
      const vw = c.viewportW, vh = c.viewportH;

      // Bod uprostřed viewportu v souřadnicích originálního obrázku – zůstane
      // uprostřed i po změně zoomu (přibližuje se/oddaluje se od středu).
      const centerImgX = (vw / 2 - c.offsetX) / c.scale;
      const centerImgY = (vh / 2 - c.offsetY) / c.scale;

      // Posuvník jde od "celá fotka vidět" (containScale, 0%) po "výrazně
      // přiblížené" (coverScale × 2, 100%) - plynulý přechod, žádný skok.
      const maxScale = c.coverScale * 2;
      c.scale = c.containScale + (zoomSlider.value / 100) * (maxScale - c.containScale);

      c.offsetX = vw / 2 - centerImgX * c.scale;
      c.offsetY = vh / 2 - centerImgY * c.scale;

      clampCropOffsets();
      applyCropTransform();
    });
  }

  // ════════════════════════════════════════════════════════════════
  // ODSTRANĚNÍ BÍLÉHO POZADÍ (flood-fill, žádná externí AI)
  // ════════════════════════════════════════════════════════════════
  // Odstraní jen bílou barvu propojenou s okrajem obrázku (= skutečné pozadí),
  // takže bílé oblasti UVNITŘ postavy (např. bílé tričko) zůstanou netknuté.
  // Spolehlivější než ML segmentace (BiRefNet) pro tenhle konkrétní případ
  // (ploché barvy, černé obrysy, garantovaně bílé pozadí z promptu) a zdarma.
  function removeWhiteBackgroundClientSide(dataUrl, threshold = 235) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width  = img.naturalWidth;
          canvas.height = img.naturalHeight;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          const { width, height } = canvas;
          const imageData = ctx.getImageData(0, 0, width, height);
          const data    = imageData.data;
          const visited = new Uint8Array(width * height);
          const stack   = [];

          const isNearWhite = (i) =>
            data[i] >= threshold && data[i + 1] >= threshold && data[i + 2] >= threshold;

          const pushIfWhite = (x, y) => {
            if (x < 0 || x >= width || y < 0 || y >= height) return;
            const idx = y * width + x;
            if (visited[idx]) return;
            const i = idx * 4;
            if (isNearWhite(i)) {
              visited[idx] = 1;
              stack.push(idx);
            }
          };

          // Začni z celého obvodu obrázku
          for (let x = 0; x < width; x++) { pushIfWhite(x, 0); pushIfWhite(x, height - 1); }
          for (let y = 0; y < height; y++) { pushIfWhite(0, y); pushIfWhite(width - 1, y); }

          while (stack.length) {
            const idx = stack.pop();
            const x = idx % width;
            const y = (idx / width) | 0;
            data[idx * 4 + 3] = 0; // alfa na 0 = průhledné
            pushIfWhite(x + 1, y);
            pushIfWhite(x - 1, y);
            pushIfWhite(x, y + 1);
            pushIfWhite(x, y - 1);
          }

          ctx.putImageData(imageData, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        } catch (err) {
          reject(err);
        }
      };
      img.onerror = () => reject(new Error("Nepodařilo se načíst obrázek pro odstranění pozadí."));
      img.src = dataUrl;
    });
  }

  // ════════════════════════════════════════════════════════════════
  // GENEROVÁNÍ
  // ════════════════════════════════════════════════════════════════
  // Společná finalizace po vygenerování (nebo po příchodu z cross-sell
  // odkazu s už hotovým obrázkem) - zobrazí výsledek, nahraje na krátké
  // odkazy (čistá verze + vypálená verze pro tenhle konkrétní produkt),
  // načte cross-sell nabídku a propíše do produktového formuláře.
  async function finalizeGeneratedImage(dataUrl) {
    state.generatedImage = dataUrl;
    state.generatedRatio = getEffectiveRatio();
    updateUidNotice();
    state.previewUrl = null;
    state.overlayOffsetX = 0;
    state.overlayOffsetY = 0;
    showStep("result");
    showGeneratedOverlay();

    const downloadBtn = document.getElementById("lf-btn-download");
    if (downloadBtn) downloadBtn.style.display = state.hasPurchasedCredits ? "block" : "none";

    // U plakátů/obrazů (zachované pozadí) design VŽDY vyplňuje celou plochu -
    // posuvník velikosti i tažení jsou tam bezpředmětné, skryjeme je.
    const sizeSliderLabel = document.getElementById("lf-mockup-size")?.closest(".lf-slider-label");
    const overlayForDrag  = document.getElementById("lf-generated-overlay");
    if (keepsBackground(state.productType)) {
      if (sizeSliderLabel) sizeSliderLabel.style.display = "none";
      if (overlayForDrag)  overlayForDrag.style.cursor = "default";
    } else {
      if (sizeSliderLabel) sizeSliderLabel.style.display = "";
      if (overlayForDrag)  overlayForDrag.style.cursor = "grab";
    }

    try {
      if (keepsBackground(state.productType)) {
        state.cleanPreviewUrl = await uploadPreviewImage(dataUrl);
        state.previewUrl = state.cleanPreviewUrl;
      } else {
        // Obě nahrání jsou na sobě nezávislá (obě čtou state.generatedImage
        // přímo) - spustíme je SOUČASNĚ místo za sebou, ať to zbytečně
        // neprodlužuje čekání zákazníka.
        const [cleanUrl, bakedUrl] = await Promise.all([
          uploadPreviewImage(dataUrl),
          buildAndUploadFinalPrintFile(),
        ]);
        state.cleanPreviewUrl = cleanUrl;
        state.previewUrl = bakedUrl;
      }
      loadCrossSell();
      injectPropertiesIntoNativeForm();
    } catch (err) {
      console.warn("[LF] Upload náhledu pro cross-sell selhal:", err.message);
    }
  }

  // Pokud zákazník přišel z cross-sell odkazu (klikl na "Zobrazit na tomhle
  // produktu" u jiného produktu), URL obsahuje ?lf_preview=<odkaz na čistý
  // obrázek>. Načteme ho a rovnou přeskočíme na výsledek, napasovaný na
  // TENHLE konkrétní produkt (jeho vlastní mockup/poměr stran).
  async function tryLoadFromCrossSellLink() {
    const params = new URLSearchParams(window.location.search);
    const previewUrl = params.get("lf_preview");
    if (!previewUrl) return false;

    try {
      const res  = await fetch(previewUrl);
      const blob = await res.blob();
      const dataUrl = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload  = () => resolve(reader.result);
        reader.onerror = () => reject(new Error("Nepodařilo se načíst obrázek."));
        reader.readAsDataURL(blob);
      });
      await finalizeGeneratedImage(dataUrl);
      return true;
    } catch (err) {
      console.warn("[LF] Načtení obrázku z cross-sell odkazu selhalo:", err.message);
      return false;
    }
  }

  // Počítadlo uplynulého času + rotující hlášky během generování - ať
  // zákazník vidí, že se něco skutečně děje, i když AI generování trvá déle
  // (typicky 15-90 vteřin, podle vytížení AI služby).
  let generatingInterval = null;
  const GENERATING_MESSAGES = [
    { at: 0,  text: "Generuji váš obrázek..." },
    { at: 8,  text: "AI pracuje na stylizaci..." },
    { at: 18, text: "Ještě chvilku, dolaďujeme detaily..." },
    { at: 35, text: "Trvá to o něco déle, díky za trpělivost..." },
    { at: 60, text: "Skoro hotovo, ještě pár vteřin..." },
  ];

  function startGeneratingProgress() {
    const textEl  = document.getElementById("lf-gen-text");
    const timerEl = document.getElementById("lf-gen-timer");
    if (!textEl || !timerEl) return;

    let seconds = 0;
    textEl.textContent  = GENERATING_MESSAGES[0].text;
    timerEl.textContent = "0 s";

    generatingInterval = setInterval(() => {
      seconds++;
      timerEl.textContent = `${seconds} s`;

      const msg = [...GENERATING_MESSAGES].reverse().find(m => seconds >= m.at);
      if (msg) textEl.textContent = msg.text;
    }, 1000);
  }

  function stopGeneratingProgress() {
    if (generatingInterval) {
      clearInterval(generatingInterval);
      generatingInterval = null;
    }
  }

  // Co poslat AI:
  //  - plakáty/obrazy (fullBleed): celý výřez v poměru produktu (obraz vyplní celou plochu),
  //  - merch (hrnky, trička, tašky...): jen tu část fotky, která je opravdu ve výřezu,
  //    v jejích SKUTEČNÝCH proporcích. Široký výřez hrnku (2:1, smaltovaný 3:1) by
  //    jinak měl po stranách prázdné pruhy a AI by je vyplnila roztažením postav do
  //    stran. Výsledek se do tiskové plochy vkládá bez deformace (contain).
  function computeAiInputRect(sx, sy, sW, sH, natW, natH, fullBleed) {
    if (fullBleed) return { x: sx, y: sy, w: sW, h: sH };
    const x1 = Math.max(0, sx), y1 = Math.max(0, sy);
    const x2 = Math.min(natW, sx + sW), y2 = Math.min(natH, sy + sH);
    if (x2 - x1 < 2 || y2 - y1 < 2) return { x: sx, y: sy, w: sW, h: sH }; // výřez mimo fotku - beze změny
    return { x: x1, y: y1, w: x2 - x1, h: y2 - y1 };
  }

  async function lfGenerate() {
    if (!state.crop) return;
    if (state.isBlocked || !state.canGenerate) { showCreditModal(); return; }
    // Variantu, kterou nejde vyrobit, nepustit do generování - kredit by
    // se spotřeboval zbytečně a košík by ji stejně zablokoval.
    const preReason = getGenerateBlockReason();
    if (preReason) { updateUidNotice(); alert(preReason); return; }

    showStep("generating");
    startGeneratingProgress();

    try {
      if (!state.originalImageDataUrl) {
        throw new Error("Chybí originální obrázek, zkuste to prosím znovu.");
      }

      // Výpočet výřezu v souřadnicích originálního obrázku – přesně odpovídá
      // tomu, co je vidět v náhledovém viewportu (žádná externí knihovna,
      // žádné hádání, plná kontrola nad výsledkem).
      const c = state.crop;
      const sx = -c.offsetX / c.scale;
      const sy = -c.offsetY / c.scale;
      const sW = c.viewportW / c.scale;
      const sH = c.viewportH / c.scale;

      const img = new Image();
      await new Promise((resolve, reject) => {
        img.onload  = resolve;
        img.onerror = () => reject(new Error("Nepodařilo se načíst obrázek pro ořez."));
        img.src = state.originalImageDataUrl;
      });

      const outputSize = 768; // dostatečné rozlišení pro kvalitní stylizaci
      const canvas  = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const cropRect = computeAiInputRect(sx, sy, sW, sH, img.naturalWidth, img.naturalHeight, keepsBackground(state.productType));
      // Délka delší strany 768 px, poměr stran = poměr posílaného výřezu (nic se nedeformuje)
      const rr = cropRect.w / cropRect.h;
      canvas.width  = rr >= 1 ? outputSize : Math.round(outputSize * rr);
      canvas.height = rr >= 1 ? Math.round(outputSize / rr) : outputSize;
      ctx.fillStyle = "#ffffff"; // prázdná místa bílá, ne černá (JPEG neumí průhlednost)
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, cropRect.x, cropRect.y, cropRect.w, cropRect.h, 0, 0, canvas.width, canvas.height);

      const croppedDataUrl = canvas.toDataURL("image/jpeg", 0.9);
      const base64 = croppedDataUrl.replace(/^data:image\/\w+;base64,/, "");

      // DEBUG: rychlá kontrola, že export dopadl rozumně, než to pošleme dál.
      console.log(`[LF] Canvas export: ${base64.length} znaků base64`);
      if (base64.length < 15000) {
        console.warn("[LF] POZOR: exportovaný obrázek je podezřele malý!");
      }

      const headers = { "Content-Type": "application/json" };
      if (state.customerId) headers["X-Customer-Id"] = state.customerId;

      const r = await fetch(`${WORKER}/generate`, {
        method: "POST",
        headers,
        body: JSON.stringify({
          imageBase64: base64,
          styleTag:    state.styleTag,
          productType: state.productType,
          gelatoUid:   state.gelatoUid,
        }),
      });

      const data = await r.json();

      if (!r.ok || !data.imageBase64) {
        if (data.error === "no_credits" || r.status === 403) {
          state.isBlocked    = true;
          state.blockedUntil = data.blockedUntil;
          updateBadge();
          stopGeneratingProgress();
          showStep("upload");
          showCreditModal();
          return;
        }
        throw new Error(data.error || "Generování selhalo");
      }

      // Aktualizuj kredity
      if (data.credits   !== undefined) { state.credits    = data.credits;   state.canGenerate = data.credits > 0; }
      if (data.remaining !== undefined) { state.remaining  = data.remaining; state.canGenerate = data.remaining > 0; }
      updateBadge();

      // ODSTRANĚNÍ POZADÍ: u merch produktů (ne plakáty/kalendáře) a stylů
      // s bílým pozadím (bgWhite) odstraníme bílou barvu přes flood-fill –
      // odstraní jen bílou propojenou s okrajem obrázku (= skutečné pozadí),
      // takže bílé oblečení uvnitř postavy zůstane netknuté.
      const productKeepsBackground = keepsBackground(state.productType);
      const mime = data.contentType || "image/jpeg";
      let finalDataUrl = `data:${mime};base64,${data.imageBase64}`;

      console.log(`[LF] productKeepsBackground=${productKeepsBackground}, data.bgWhite=${data.bgWhite}, productType=${state.productType}`);

      if (!productKeepsBackground && data.bgWhite) {
        console.log("[LF] Spouštím odstranění bílého pozadí...");
        try {
          finalDataUrl = await removeWhiteBackgroundClientSide(finalDataUrl, 225);
          console.log("[LF] Odstranění pozadí dokončeno, výsledná délka:", finalDataUrl.length);
        } catch (err) {
          console.warn("[LF] Odstranění pozadí selhalo, používám originál s bílým pozadím:", err.message);
        }
      } else {
        console.log("[LF] Odstranění pozadí se PŘESKAKUJE (productKeepsBackground nebo bgWhite=false).");
      }

      await finalizeGeneratedImage(finalDataUrl);
      stopGeneratingProgress();

    } catch (err) {
      console.error("Generate error:", err);
      stopGeneratingProgress();
      showStep("upload");
      alert(`Chyba při generování: ${err.message}`);
    }
  }

  // ════════════════════════════════════════════════════════════════
  // CSS OVERLAY – zobrazí vygenerovaný obrázek přes mockup
  // Žádný Canvas, žádný CORS problém
  // ════════════════════════════════════════════════════════════════
  function showGeneratedOverlay() {
    // Nastav vygenerovaný obrázek
    const generatedImg = document.getElementById("lf-generated-img");
    if (generatedImg && state.generatedImage) {
      generatedImg.src = state.generatedImage;
      generatedImg.style.display = "block";
    }

    // Načti mockup
    const mockupEl = document.getElementById("lf-mockup-img");
    if (mockupEl && (!mockupEl.src || mockupEl.src.includes("/products/"))) {
      loadMockupImage();
    }

    // Počkej na načtení a zobraz overlay
    setTimeout(updateOverlay, 100);
  }

  // Tažení vygenerovaného obrázku po mockupu myší/prstem. Posouvá
  // state.overlayOffsetX/Y (v procentních bodech kontejneru), volně omezené
  // na plochu mockupu - přesné omezení na tiskovou plochu doladíme později,
  // až budou k dispozici přesná Gelato data o hranicích tiskové plochy.
  let overlayDragBound = false;
  function bindOverlayDrag() {
    if (overlayDragBound) return; // listener stačí navázat jednou
    overlayDragBound = true;

    const overlay = document.getElementById("lf-generated-overlay");
    const container = document.getElementById("lf-mockup-container");
    if (!overlay || !container) return;

    overlay.style.pointerEvents = "auto";
    overlay.style.cursor = "grab";
    overlay.style.touchAction = "none";

    let dragStart = null;

    overlay.addEventListener("pointerdown", (e) => {
      const mockupEl = document.getElementById("lf-mockup-img");
      if (mockupEl && mockupEl.style.display === "none") return; // fallback bez mockupu - netahat
      if (keepsBackground(state.productType)) return; // plakáty/obrazy - design vždy vyplňuje celou plochu
      dragStart = {
        x: e.clientX, y: e.clientY,
        offsetX: state.overlayOffsetX, offsetY: state.overlayOffsetY,
      };
      overlay.setPointerCapture(e.pointerId);
      overlay.style.cursor = "grabbing";
    });

    overlay.addEventListener("pointermove", (e) => {
      if (!dragStart) return;
      const rect = container.getBoundingClientRect();
      const dxPercent = ((e.clientX - dragStart.x) / rect.width)  * 100;
      const dyPercent = ((e.clientY - dragStart.y) / rect.height) * 100;

      // Volná pojistka: nedovol posun tak daleko, aby obrázek úplně opustil mockup.
      state.overlayOffsetX = Math.max(-40, Math.min(40, dragStart.offsetX + dxPercent));
      state.overlayOffsetY = Math.max(-40, Math.min(40, dragStart.offsetY + dyPercent));
      updateOverlay();
    });

    const endDrag = () => { dragStart = null; overlay.style.cursor = "grab"; };
    overlay.addEventListener("pointerup",     endDrag);
    overlay.addEventListener("pointercancel", endDrag);
  }

  function updateOverlay() {
    const overlay = document.getElementById("lf-generated-overlay");
    if (!overlay) return;

    // Pokud je mockup skrytý (fallback bez produktového obrázku), overlay je
    // nastavený na position:static přes celou plochu – neaplikuj procentuální
    // pozicování, jinak by se přepsalo zpátky na position:absolute layout.
    const mockupEl = document.getElementById("lf-mockup-img");
    if (mockupEl && mockupEl.style.display === "none") return;

    const config = state.productConfig || { printX: 20, printY: 18, printW: 60, printH: 64 };

    // Uživatelské doladění velikosti posuvníkem, škáluje se kolem STEJNÉHO
    // středu tiskové zóny (default 100 % = přesně podle konfigurace produktu).
    const sizeScale = (document.getElementById("lf-mockup-size")?.value || 100) / 100;
    // + posun tažením myší/prstem (state.overlayOffsetX/Y, v procentních bodech).
    // POZOR: zatím jen volně omezené na plochu mockupu, ne přísně na přesnou
    // tiskovou plochu - tu doladíme, až budou k dispozici přesná Gelato data.
    const centerX = config.printX + config.printW / 2 + state.overlayOffsetX;
    const centerY = config.printY + config.printH / 2 + state.overlayOffsetY;
    const width   = config.printW * sizeScale;
    const height  = config.printH * sizeScale;

    overlay.style.position = "absolute";
    overlay.style.left   = `${centerX - width / 2}%`;
    overlay.style.top    = `${centerY - height / 2}%`;
    overlay.style.width  = `${width}%`;
    overlay.style.height = `${height}%`;

    // Přepočítej i finální tiskový soubor - ať to, co se pošle do košíku,
    // vždycky odpovídá aktuální velikosti/pozici, ne jen stavu hned po
    // vygenerování. Debounced, ať nespamujeme upload při každém pixelu tažení.
    scheduleRebakePrintFile();
  }

  let rebakeTimeout = null;
  function scheduleRebakePrintFile() {
    if (keepsBackground(state.productType)) return; // plakáty/canvas nemají size/position úpravu
    clearTimeout(rebakeTimeout);
    rebakeTimeout = setTimeout(async () => {
      try {
        const bakedUrl = await buildAndUploadFinalPrintFile();
        if (bakedUrl) {
          state.previewUrl = bakedUrl;
          injectPropertiesIntoNativeForm();
        }
      } catch (err) {
        console.warn("[LF] Přepočet finálního tiskového souboru selhal:", err.message);
      }
    }, 400);
  }

  // Sestaví finální tiskový soubor přesně podle toho, co zákazník vidí na
  // mockupu (velikost + posun), na canvasu s PŘESNÝM poměrem stran tiskové
  // plochy produktu (config.ratio) - ne surový vygenerovaný obrázek. Díky
  // tomu, i když se naše odhadovaná pozice na mockup FOTCE mírně liší od
  // skutečnosti, to, co se skutečně vytiskne, vždy odpovídá tomu, co si
  // zákazník na obrazovce nastavil (stejná relativní velikost/pozice).
  // Posun motivu v náhledu je v % MOCKUPU (kontejneru), ale soubor ho potřebuje
  // jako zlomek TISKOVÉ PLOCHY. Tisková plocha je printW % šířky mockupu a její
  // výška v pixelech je šířka / poměr stran. Bez přepočtu se tažením posunutý
  // motiv ve výsledném souboru posunul jen o zlomek toho, co ukazoval náhled.
  function overlayOffsetToPrintFraction(offX, offY, cfg, ratio, cw, ch) {
    if (!cfg || !cfg.printW || !ratio || !cw || !ch) return { x: offX / 100, y: offY / 100 }; // záloha
    const areaWpx = cfg.printW / 100 * cw;
    const areaHpx = areaWpx / ratio;
    return { x: (offX / 100 * cw) / areaWpx, y: (offY / 100 * ch) / areaHpx };
  }

  async function buildAndUploadFinalPrintFile() {
    if (!state.generatedImage || !state.productConfig) return null;

    const img = new Image();
    await new Promise((resolve, reject) => {
      img.onload  = resolve;
      img.onerror = () => reject(new Error("Nepodařilo se načíst vygenerovaný obrázek."));
      img.src = state.generatedImage;
    });

    const ratio = getEffectiveRatio();
    // Rozlišení tiskového souboru. U merche (průhledné pozadí) se soubor po
    // zaplacení NEZVĚTŠUJE (AuraSR zahodí průhlednost a udělá černý čtverec),
    // takže musí mít dost pixelů rovnou: 3000 px na delší straně = cca 190 dpi
    // u trika 12x16", víc u hrnků a tašek. (Plakáty/obrazy se zvětšují na serveru.)
    const outputLong = 3000;
    const canvas = document.createElement("canvas");
    canvas.width  = ratio >= 1 ? outputLong : Math.round(outputLong * ratio);
    canvas.height = ratio >= 1 ? Math.round(outputLong / ratio) : outputLong;
    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high"; // kvalitní zvětšení z ~1000 px obrázku z AI
    // Průhledné pozadí (merch produkty mají už odstraněné pozadí z generování)

    const sizeScale = (document.getElementById("lf-mockup-size")?.value || 100) / 100;
    const holder = document.getElementById("lf-mockup-container");
    const off = overlayOffsetToPrintFraction(state.overlayOffsetX, state.overlayOffsetY, state.productConfig, ratio, holder?.clientWidth, holder?.clientHeight);
    const offsetXFrac = off.x;
    const offsetYFrac = off.y;

    // "object-fit: contain" logika obrázku uvnitř škálovaného/posunutého boxu,
    // stejná matematika jako CSS overlay, jen na canvasu místo v DOM.
    const boxW = canvas.width  * sizeScale;
    const boxH = canvas.height * sizeScale;
    const imgRatio = img.naturalWidth / img.naturalHeight;
    const boxRatio = boxW / boxH;

    let drawW, drawH;
    if (imgRatio > boxRatio) { drawW = boxW; drawH = boxW / imgRatio; }
    else                     { drawH = boxH; drawW = boxH * imgRatio; }

    const centerX = canvas.width  * (0.5 + offsetXFrac);
    const centerY = canvas.height * (0.5 + offsetYFrac);

    ctx.drawImage(img, centerX - drawW / 2, centerY - drawH / 2, drawW, drawH);

    const dataUrl = canvas.toDataURL("image/png");
    return await uploadPreviewImage(dataUrl);
  }

  // ════════════════════════════════════════════════════════════════
  // CROSS-SELL – stejný vygenerovaný obrázek nabídnutý na dalších produktech
  // stejného stylu (ze Shopify kolekce), bez nutnosti nového generování.
  // ════════════════════════════════════════════════════════════════
  async function loadCrossSell() {
    const container = document.getElementById("lf-crosssell");
    if (!container || !state.previewUrl) return;

    const handle = STYLE_COLLECTIONS[state.styleTag];
    if (!handle) { container.innerHTML = ""; return; }

    container.innerHTML = `<p class="lf-crosssell-loading">Načítám další produkty...</p>`;

    let products;
    try {
      const res  = await fetch(`/collections/${handle}/products.json?limit=20`);
      const data = await res.json();
      products = data.products || [];
    } catch (err) {
      console.warn("[LF] Cross-sell: načtení kolekce selhalo:", err.message);
      container.innerHTML = "";
      return;
    }

    // Gelato mapa se teď dohledává podle typu produktu + barvy (viz
    // resolveGelatoUid), ne podle handle - jedna fyzická taška má stejné UID
    // bez ohledu na styl/design, takže mapu sdílíme napříč cross-sell produkty.

    // Vynech aktuální produkt (ten, co si zákazník právě personalizuje)
    const others = products.filter(p => p.handle !== state.productHandle);
    if (others.length === 0) { container.innerHTML = ""; return; }

    container.innerHTML = `
      <p class="lf-crosssell-title">✨ Stejný obrázek i na dalších produktech:</p>
      <div class="lf-crosssell-grid" id="lf-crosssell-grid"></div>
    `;
    const grid = document.getElementById("lf-crosssell-grid");

    for (const product of others) {
      const tags = (product.tags || []).map(t => String(t));
      const productTypeTag = resolveProductTypeTag(tags);
      const config = PRODUCT_TYPES[productTypeTag] || PRODUCT_TYPES["product_tshirt"];

      const variantId = product.variants?.[0]?.id;
      if (!variantId || !productTypeTag) continue;

      // Barva té konkrétní (výchozí/první) varianty tohoto cross-sell produktu
      // Barva a velikost té konkrétní (výchozí/první) varianty cross-sell produktu.
      // Shopify obvykle: option1 = barva, option2 = velikost (pokud produkt obojí má).
      const variantColor = product.variants?.[0]?.option1 || "";
      const variantSize  = product.variants?.[0]?.option2 || "";
      const gelatoUidTag = await resolveGelatoUid(productTypeTag, variantColor, product.handle, variantSize);

      if (!gelatoUidTag) {
        console.warn(`[LF] Cross-sell: chybí gelatoUid pro "${productTypeTag}:${variantSize}:${variantColor}" (produkt "${product.handle}") v GELATO_UID_MAP (worker.js) - přeskočeno.`);
        continue; // nepřidávej produkt, u kterého bychom neuměli dokončit tisk
      }

      // Mockup obrázek = druhý obrázek produktu (konvence: 1. vzorek, 2. mockup)
      const mockupSrc = product.images?.[1]?.src || product.images?.[0]?.src || "";

      // Odkaz na stránku produktu s "čistým" obrázkem (jen odstraněné pozadí,
      // ještě nenapasovaným na poměr stran tohoto konkrétního produktu)
      // předaným v URL - widget na cílové stránce ho sám napasuje na svůj
      // vlastní tvar a poměr stran.
      const targetUrl = `/products/${product.handle}?lf_preview=${encodeURIComponent(state.cleanPreviewUrl)}&lf_style=${encodeURIComponent(state.styleTag)}`;

      const card = document.createElement("div");
      card.className = "lf-crosssell-card";
      card.innerHTML = `
        <div class="lf-crosssell-mockup" style="aspect-ratio:${config.ratio}">
          <img class="lf-crosssell-mockup-img" src="${mockupSrc}" alt="${product.title}">
          <div class="lf-crosssell-overlay" style="left:${config.printX}%;top:${config.printY}%;width:${config.printW}%;height:${config.printH}%;">
            <img src="${state.previewUrl}" alt="Náhled">
          </div>
        </div>
        <p class="lf-crosssell-name">${product.title}</p>
        <a href="${targetUrl}" class="lf-btn lf-btn--outline lf-crosssell-btn">Zobrazit na tomhle produktu</a>
      `;

      grid.appendChild(card);
    }
  }

  // ════════════════════════════════════════════════════════════════
  // KOŠÍK
  // ════════════════════════════════════════════════════════════════
  // Nahraje obrázek (data: URL) na Worker a vrátí krátký odkaz. Používá se
  // hned po vygenerování (aby byl odkaz připravený i pro cross-sell nabídku)
  // i v lfAddToCart jako pojistka, pokud by se ten první upload nezdařil.
  async function uploadPreviewImage(dataUrl, retries = 2) {
    const [, mimePart, base64Part] = dataUrl.match(/^data:([^;]+);base64,(.+)$/) || [];
    if (!base64Part) throw new Error("Neplatný formát obrázku.");

    let lastError;
    for (let i = 0; i <= retries; i++) {
      try {
        const uploadRes = await fetch(`${WORKER}/store-image`, {
          method:  "POST",
          headers: { "Content-Type": "application/json" },
          body:    JSON.stringify({ imageBase64: base64Part, contentType: mimePart }),
        });
        const uploadData = await uploadRes.json();

        if (!uploadRes.ok || !uploadData.url) {
          throw new Error(uploadData.error || "Nahrání náhledu selhalo.");
        }
        return uploadData.url;
      } catch (err) {
        lastError = err;
        console.warn(`[LF] Upload náhledu selhal (pokus ${i + 1}/${retries + 1}):`, err.message);
        if (i < retries) await new Promise(r => setTimeout(r, 800 * (i + 1))); // krátká prodleva před opakováním
      }
    }
    throw lastError;
  }

  // Stáhne aktuálně vygenerovaný obrázek v tiskové kvalitě (4x upscale) -
  // benefit pro registrované zákazníky s zakoupenými kredity, na vlastní tisk
  // mimo náš e-shop.
  async function lfDownloadPrintQuality() {
    if (!state.generatedImage || !state.customerId) return;

    // Používáme už hotový soubor (previewUrl - vypálený, přesně napasovaný
    // na tiskovou plochu) - ŽÁDNÉ nové AI zvětšení. AuraSR se ukázal jako
    // nespolehlivý (30s-4min+, občas nedoběhne vůbec) - lepší spolehlivá
    // rychlá verze než teoreticky lepší kvalita, co nefunguje.
    const downloadUrl = state.previewUrl || state.cleanPreviewUrl;
    if (!downloadUrl) {
      alert("Náhled ještě není připravený, zkuste to prosím za chvíli znovu.");
      return;
    }

    const btn = document.getElementById("lf-btn-download");
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Ověřuji oprávnění...";

    try {
      // Rychlá server-side kontrola (ne jen spoléhání na viditelnost tlačítka
      // v prohlížeči) - ověří, že zákazník SKUTEČNĚ zaplatil za kredity.
      const res = await fetch(`${WORKER}/download-quality`, {
        method:  "POST",
        headers: { "X-Customer-Id": state.customerId },
      });
      const data = await res.json();

      if (!res.ok || !data.authorized) {
        throw new Error(data.error || "Stažení není povolené.");
      }

      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `losfiltros-${getStyleName(state.styleTag)}-tiskova-kvalita.png`;
      document.body.appendChild(a);
      a.click();
      a.remove();

      btn.textContent = "✓ Staženo";
    } catch (err) {
      alert(`Stažení selhalo: ${err.message}`);
    } finally {
      setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 3000);
    }
  }

  // Vloží skrytá pole s personalizací do EXISTUJÍCÍHO produktového formuláře
  // na stránce (to, co používá hlavní "Přidat do košíku" tlačítko motivu),
  // ať se personalizace přenese automaticky bez potřeby vlastního tlačítka
  // ve widgetu. Funguje, protože standardní Shopify formuláře čtou i skrytá
  // pole při odeslání (FormData bere všechna pole formuláře, ne jen viditelná).
  function injectPropertiesIntoNativeForm() {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) {
      console.warn("[LF] Nenašel jsem produktový formulář (form[action*='/cart/add']) - personalizace se nemusí přenést do košíku. Zvaž vrácení vlastního tlačítka jako zálohy.");
      return false;
    }

    // Smaž případná dřív vložená pole (např. po kliknutí na "Znovu" a novém generování)
    form.querySelectorAll('[data-lf-injected]').forEach(el => el.remove());

    const props = {
      "_preview_url":  state.previewUrl,
      "_style":        state.styleTag,
      "_product_type": state.productType,
      "_gelato_uid":   state.gelatoUid,
      "Styl":          getStyleName(state.styleTag),
      "Personalizace": "Ano – vlastní fotka",
    };

    Object.entries(props).forEach(([key, value]) => {
      if (!value) return;
      const input = document.createElement("input");
      input.type  = "hidden";
      input.name  = `properties[${key}]`;
      input.value = value;
      input.setAttribute("data-lf-injected", "true");
      form.appendChild(input);
    });

    console.log("[LF] Personalizace vložena do produktového formuláře, hlavní tlačítko 'Přidat do košíku' ji teď zahrne.");
    return true;
  }

  async function lfAddToCart() {
    if (!state.generatedImage) return;

    const variantInput = document.querySelector('input[name="id"], select[name="id"]');
    const variantId    = variantInput?.value;

    if (!variantId) {
      alert("Prosím nejdřív vyberte variantu (velikost, barvu).");
      return;
    }

    // OPRAVA "Košík je příliš velký": Shopify má limit na velikost cart
    // properties, náš base64 PNG obrázek (>1MB textu) ho spolehlivě přesáhne.
    // previewUrl je normálně už připravený z lfGenerate (viz state.previewUrl),
    // sem se dostaneme jen jako pojistka, kdyby se to napoprvé nepovedlo.
    let previewUrl = state.previewUrl;
    if (!previewUrl) {
      try {
        previewUrl = await uploadPreviewImage(state.generatedImage);
      } catch (err) {
        alert(`Chyba při přípravě obrázku: ${err.message}. Zkuste to prosím znovu.`);
        return;
      }
    }

    const cartData = {
      id:       variantId,
      quantity: 1,
      properties: {
        "_preview_url":  previewUrl,
        "_style":        state.styleTag,
        "_product_type": state.productType,
        "_gelato_uid":   state.gelatoUid,
        "Styl":          getStyleName(state.styleTag),
        "Personalizace": "Ano – vlastní fotka",
      },
    };

    try {
      const response = await fetch("/cart/add.js", {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify(cartData),
      });

      if (response.ok) {
        window.location.href = "/cart";
      } else {
        const err = await response.json();
        alert(`Chyba: ${err.description || "Zkuste to znovu"}`);
      }
    } catch (err) {
      alert("Chyba při přidání do košíku.");
    }
  }

  // ════════════════════════════════════════════════════════════════
  // KREDITY
  // ════════════════════════════════════════════════════════════════
  async function loadCreditStatus() {
    try {
      const headers = {};
      if (state.customerId) headers["X-Customer-Id"] = state.customerId;
      const r = await fetch(`${WORKER}/status`, { headers });
      const d = await r.json();
      state.credits      = d.credits      ?? 0;
      state.remaining    = d.remaining    ?? 3;
      state.freeLimit    = d.freeLimit    ?? 3;
      state.canGenerate  = d.canGenerate  ?? true;
      state.isBlocked    = d.isBlocked    ?? false;
      state.blockedUntil = d.blockedUntil ?? null;
      state.hasPurchasedCredits = d.hasPurchasedCredits ?? false;
    } catch (_) { state.canGenerate = true; }
    updateBadge();
  }

  function updateBadge() {
    const badge = document.getElementById("lf-badge");
    if (!badge) return;

    if (state.isBlocked) {
      const t = timeLeft(state.blockedUntil);
      badge.innerHTML = `<span class="lf-dot lf-dot--red"></span>Zablokováno${t ? " · " + t : ""}`;
      badge.className = "lf-badge lf-badge--blocked";
      badge.onclick   = showCreditModal;
      return;
    }
    if (state.customerId && state.credits !== undefined) {
      const empty = state.credits === 0;
      badge.innerHTML = `<span class="lf-dot" style="background:${empty ? "#ef4444" : "#22c55e"}"></span>Kredity: <strong>${state.credits}</strong>`;
      badge.className = `lf-badge${empty ? " lf-badge--warn" : ""}`;
      badge.onclick   = empty ? showCreditModal : null;
    } else {
      const rem   = state.remaining ?? 3;
      const color = rem <= 1 ? "#ef4444" : rem <= 2 ? "#f97316" : "#22c55e";
      badge.innerHTML = `<span class="lf-dot" style="background:${color}"></span>Zdarma: <strong>${rem}/${state.freeLimit ?? 3}</strong>`;
      badge.className = `lf-badge${rem <= 1 ? " lf-badge--warn" : ""}`;
    }
  }

  function showCreditModal() {
    const modal      = document.getElementById("lf-modal");
    if (!modal) return;
    const isCustomer = !!state.customerId;
    const t          = timeLeft(state.blockedUntil);

    document.getElementById("lf-modal-icon").textContent  = isCustomer ? "💳" : "⏳";
    document.getElementById("lf-modal-title").textContent = isCustomer ? "Kredity vyčerpány" : "Generování vyčerpáno";
    document.getElementById("lf-modal-body").innerHTML    = isCustomer
      ? `Váš kredit je vyčerpán.<br>Kupte nové kredity a pokračujte okamžitě.`
      : `Využili jste všechna bezplatná generování.${t ? `<br><strong>Přístup se obnoví za: ${t}</strong>` : ""}<br><br>Zaregistrujte se nebo kupte kredity.`;

    const regBtn = document.getElementById("lf-modal-register");
    if (regBtn) regBtn.style.display = isCustomer ? "none" : "block";

    modal.classList.add("lf-modal--open");
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    const modal = document.getElementById("lf-modal");
    if (modal) modal.classList.remove("lf-modal--open");
    document.body.style.overflow = "";
  }

  // ════════════════════════════════════════════════════════════════
  // HELPERS
  // ════════════════════════════════════════════════════════════════
  function showStep(step) {
    ["upload", "crop", "generating", "result"].forEach(s => {
      const el = document.getElementById(`lf-step-${s}`);
      if (el) el.classList.toggle("lf-step--active", s === step);
    });
  }

  function lfReset() {
    state.generatedImage = null;
    state.previewUrl = null;
    state.originalImageDataUrl = null;
    state.crop = null;
    state.overlayOffsetX = 0;
    state.overlayOffsetY = 0;
    const fi = document.getElementById("lf-file-input");
    if (fi) fi.value = "";
    const sizeSlider = document.getElementById("lf-mockup-size");
    if (sizeSlider) sizeSlider.value = 100;
    const crossSell = document.getElementById("lf-crosssell");
    if (crossSell) crossSell.innerHTML = "";
    const downloadBtn = document.getElementById("lf-btn-download");
    if (downloadBtn) downloadBtn.style.display = "none";
    document.querySelectorAll('[data-lf-injected]').forEach(el => el.remove());
    showStep("upload");
  }

  function getStyleName(tag) {
    const names = {
      style_yellowtown:  "Žluté Městečko",
      style_anime:       "Anime",
      style_comics:      "Komiks",
      style_popart:      "Pop-Art",
      style_oilpainting: "Královská Olejomalba",
      style_cyberpunk:   "Cyber-Punk",
      style_watercolor:  "Akvarel",
    };
    return names[tag] || tag;
  }

  function timeLeft(until) {
    if (!until) return null;
    const ms = Math.max(0, until - Date.now());
    return `${Math.floor(ms / 3600000)} hod ${Math.floor((ms % 3600000) / 60000)} min`;
  }

  // ════════════════════════════════════════════════════════════════
  // STYLY
  // ════════════════════════════════════════════════════════════════
  function injectStyles() {
    document.head.insertAdjacentHTML("beforeend", `<style>
      #lf-widget { margin: 24px 0; font-family: system-ui, sans-serif; max-width: 100%; overflow-x: hidden; }
      .lf-inner { border: 1.5px solid #e8e3ff; border-radius: 16px; padding: 20px; background: #faf9ff; box-sizing: border-box; max-width: 100%; }
      .lf-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; flex-wrap: wrap; gap: 8px; }
      .lf-title { font-size: 16px; font-weight: 700; color: #1a1040; margin: 0; }

      .lf-step { display: none; }
      .lf-step--active { display: block; }
      .lf-step-label { font-size: 13px; color: #666; margin: 0 0 10px; }
      .lf-actions { display: flex; gap: 10px; margin-top: 14px; flex-wrap: wrap; }

      .lf-upload-zone { border: 2px dashed #c4b5fd; border-radius: 12px; padding: 32px 20px; text-align: center; cursor: pointer; transition: border-color .2s, background .2s; }
      .lf-upload-zone:hover, .lf-upload-zone--drag { border-color: #7c5cfc; background: #f5f3ff; }
      .lf-upload-icon { font-size: 40px; margin-bottom: 10px; }
      .lf-upload-text { font-size: 15px; font-weight: 600; color: #1a1040; margin: 0 0 4px; }
      .lf-upload-sub { font-size: 12px; color: #999; margin: 0 0 14px; }

      .lf-crop-outer { display: flex; justify-content: center; margin-bottom: 12px; }
      .lf-crop-viewport { position: relative; overflow: hidden; background: #eee; border-radius: 10px; cursor: grab; touch-action: none; box-shadow: 0 0 0 2px #e8e3ff; }
      .lf-crop-viewport--dragging, .lf-crop-viewport:active { cursor: grabbing; }
      .lf-crop-img { position: absolute; top: 0; left: 0; user-select: none; pointer-events: none; max-width: none; }

      .lf-generating { text-align: center; padding: 40px 20px; }
      .lf-spinner { width: 48px; height: 48px; border: 4px solid #e8e3ff; border-top-color: #7c5cfc; border-radius: 50%; animation: lfSpin .8s linear infinite; margin: 0 auto 16px; }
      @keyframes lfSpin { to { transform: rotate(360deg); } }
      .lf-gen-text { font-size: 16px; font-weight: 600; color: #1a1040; margin: 0 0 6px; }
      .lf-gen-sub { font-size: 13px; color: #999; margin: 0; }

      /* Preview s CSS overlay */
      .lf-preview-wrap { display: flex; justify-content: center; margin-bottom: 16px; }
      .lf-mockup-container { position: relative; width: 380px; max-width: 100%; background: #f5f5f5; border-radius: 8px; overflow: hidden; }
      .lf-mockup-img { width: 100%; height: 100%; object-fit: contain; display: block; border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,.1); }
      .lf-generated-overlay { position: absolute; }
      .lf-generated-img { width: 100%; height: 100%; object-fit: contain; display: block; }

      .lf-slider-label { font-size: 12px; color: #666; display: flex; align-items: center; gap: 10px; }
      .lf-cart-hint { font-size: 12px; color: #16a34a; text-align: center; margin: 4px 0 0; font-weight: 600; }
      .lf-slider-label input[type=range] { flex: 1; accent-color: #7c5cfc; }

      .lf-badge { display: inline-flex; align-items: center; gap: 6px; background: #fff; border: 1.5px solid #e8e3ff; border-radius: 99px; padding: 5px 12px; font-size: 12px; color: #333; cursor: default; }
      .lf-badge strong { color: #7c5cfc; }
      .lf-badge--blocked { border-color: #fecaca; background: #fff5f5; cursor: pointer; }
      .lf-badge--warn { border-color: #fed7aa; }
      .lf-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; animation: lfPulse 2s infinite; }
      .lf-dot--red { background: #ef4444; }
      @keyframes lfPulse { 0%,100%{opacity:1} 50%{opacity:.4} }

      .lf-btn { display: inline-flex; align-items: center; justify-content: center; padding: 11px 20px; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; border: none; text-decoration: none; transition: transform .15s, opacity .15s; flex: 1; }
      .lf-btn:hover { transform: translateY(-1px); opacity: .9; }
      .lf-btn:disabled { opacity: .5; cursor: wait; transform: none; }
      .lf-btn--primary { background: linear-gradient(135deg, #7c5cfc, #5b3fd4); color: #fff; }
      .lf-btn--success { background: linear-gradient(135deg, #22c55e, #16a34a); color: #fff; }
      .lf-btn--outline { background: #fff; color: #5b3fd4; border: 1.5px solid #c4b5fd; }

      .lf-modal { display: none; position: fixed; inset: 0; z-index: 99999; align-items: center; justify-content: center; }
      .lf-modal--open { display: flex; }
      .lf-modal-backdrop { position: absolute; inset: 0; background: rgba(10,5,30,.6); backdrop-filter: blur(4px); }
      .lf-modal-box { position: relative; z-index: 1; background: #fff; border-radius: 20px; padding: 40px 36px 32px; max-width: 420px; width: 92%; text-align: center; box-shadow: 0 24px 64px rgba(10,5,30,.25); animation: lfUp .28s cubic-bezier(.34,1.56,.64,1); }
      @keyframes lfUp { from{transform:translateY(36px) scale(.96);opacity:0} to{transform:none;opacity:1} }
      .lf-modal-close { position: absolute; top: 14px; right: 14px; width: 28px; height: 28px; border-radius: 50%; background: #f5f3ff; border: none; font-size: 13px; color: #888; cursor: pointer; }
      .lf-modal-icon { font-size: 48px; line-height: 1; margin-bottom: 12px; }
      .lf-modal-title { font-size: 20px; font-weight: 700; color: #1a1040; margin: 0 0 10px; }
      .lf-modal-body { font-size: 14px; color: #555; line-height: 1.65; margin: 0 0 22px; }
      .lf-modal-body strong { color: #1a1040; }
      .lf-modal-btns { display: flex; flex-direction: column; gap: 10px; }
      .lf-modal-note { font-size: 11px; color: #bbb; margin: 14px 0 0; }

      .lf-crosssell { margin-top: 20px; padding-top: 16px; border-top: 1px solid #e8e3ff; }
      .lf-crosssell-loading { font-size: 12px; color: #999; text-align: center; }
      .lf-crosssell-title { font-size: 13px; font-weight: 600; color: #1a1040; margin: 0 0 10px; }
      .lf-crosssell-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)); gap: 10px; }
      .lf-crosssell-card { text-align: center; }
      .lf-crosssell-mockup { position: relative; width: 100%; background: #f5f5f5; border-radius: 8px; overflow: hidden; }
      .lf-crosssell-mockup-img { width: 100%; height: 100%; object-fit: contain; display: block; }
      .lf-crosssell-overlay { position: absolute; pointer-events: none; }
      .lf-crosssell-overlay img { width: 100%; height: 100%; object-fit: contain; display: block; }
      .lf-crosssell-name { font-size: 11px; color: #555; margin: 6px 0 4px; line-height: 1.3; }
      .lf-crosssell-btn { width: 100%; padding: 6px 8px; font-size: 11px; }

      @media (max-width: 480px) {
        .lf-modal-box { padding: 32px 20px 24px; }
        .lf-inner { padding: 14px; }
        .lf-mockup-container { width: 100%; }
      }
    </style>`);
  }

  // ── Start ──
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();